import * as yup from 'yup';

import { RenderConfig, Row, SelectInput } from 'commons-ui';
import { TYPE_OPTIONS } from './constants';

export const FORM_FIELD_KEYS = {
	BEHAVIOUR: 'behaviour'
};

export const validationSchema = yup.object().shape({
	behaviour: yup.string().required('Behaviour is a required field')
});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.BEHAVIOUR]: new RenderConfig()
		.setName('behaviour')
		.setLabel('Behaviour')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: TYPE_OPTIONS,
			required: true
		})
};

export const FORM_LAYOUT_CONFIG = [new Row(FORM_FIELD_KEYS.BEHAVIOUR)];
